import React, { useState, useEffect } from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { getChatPrescCompletion } from "../../../api/apiHandler";
import PatientInfoPop from "./PatientInfoPopup";
import DoctorInfoPopup from "./DoctorInfoPopup";
import QRCodePop from "../../doctor/prescription/QrCodePop/index.jsx";
import Swal from "sweetalert2";
import styled from "styled-components";
import moment from "moment";
import { EmailPrescriptionPopup } from "../../../modal/emailPrescriptionPopup/index.js";
import PriestMeetingRecord from "../../doctor/meeting-record/PriestMeetingRecord.js";

function PostralReport() {
  const params = useParams();
  console.log("paramssss", params);
  const navigate = useNavigate();
  const [prescriptionId, setPrescriptionId] = useState(params.id);
  const [medicineList, setMedicineList] = useState();
  console.log("medicineList12xs03s", medicineList);
  const [showPatiendInfo, setShowPatientInfo] = useState(false);
  const [typepres, settypepres] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [showDoctorInfo, setShowDoctorInfo] = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [doctorData, setDoctorData] = useState(null);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [doctorDataDetails, setDoctorDataDetails] = useState(null);
  const [qrCode, setQrCode] = useState();
  const handlePatientInfo = () => setShowPatientInfo(!showPatiendInfo);
  const handleDoctorInfo = () => setShowDoctorInfo(!showDoctorInfo);
  const handleQRCode = () => setQrCode(!qrCode);
  const isOpenMailModal = (prescription) => {
    const userRole = localStorage.getItem("user_login_type_role");

    if (!userRole) {
      navigate("/");
      return;
    }

    setIsOpen(true);
  };
  const [meetinId, setMeetingId] = useState(null);
  useEffect(() => {
    if (prescriptionId) {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const findPrescriptionObj = {
        id: prescriptionId,
      };

      getChatPrescCompletion(findPrescriptionObj).then((response) => {
        try {
          response = JSON.parse(response);
          Swal.close();

          if (response.code == process.env.REACT_APP_SUCCESS) {
            setMeetingId(response.data?.meeting_id);

            // Safely parse patientInfo
            let patientData =
              typeof response.data.data.patientInfo === "string" &&
              response.data.data.patientInfo
                ? JSON.parse(response.data.data.patientInfo)
                : response.data.data.patientInfo || {};

            // Safely parse doctorInfo
            let doctorData =
              typeof response.data.data.doctorInfo === "string" &&
              response.data.data.doctorInfo
                ? JSON.parse(response.data.data.doctorInfo)
                : response.data.data.doctorInfo || {};

            // Safely parse precription
            let medicineList =
              typeof response.data.data.precription === "string" &&
              response.data.data.precription
                ? JSON.parse(response.data.data.precription)
                : response.data.data.precription || [];

            let qrurl = response.data.data.qrCode;

            setQrCodeUrl(qrurl);
            setMedicineList(medicineList);
            setPatientData(patientData);
            setDoctorData(doctorData);
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "error message", // response.message,
              toast: true,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (err) {
          Swal.close();
          console.error("Parsing error:", err, response);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Invalid response format",
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    }
  }, []);
  console.log(medicineList, "medicineList23eds21");

  return (
    <>
      <EmailPrescriptionPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        medicineList={medicineList}
        doctorData={doctorData}
        patientData={patientData}
        paramsID={params}
      />
      <PatientInfoPop
        showPatiendInfo={showPatiendInfo}
        setShowPatientInfo={setShowPatientInfo}
        patientData={patientData}
      />
      <DoctorInfoPopup
        showDoctorInfo={showDoctorInfo}
        setShowDoctorInfo={setShowDoctorInfo}
        doctorData={doctorData}
      />
      <QRCodePop
        datePresc={moment().utc().format("D MMMM YYYY")}
        qrCodeUrl={qrCodeUrl}
        docData={doctorData}
        patientData={patientData}
        medicineList={medicineList}
        fromEmailMeetingId={meetinId ? meetinId : medicineList?.[0]?.meeting_id}
        qrCode={qrCode}
        setQrCode={setQrCode}
      />
      <main className="bg-color flex-column">
        <section className="doctorsec-pad share-medical">
          <div className="container">
            <div className="card">
              <div className="card-body doctor-table-card">
                <PriestMeetingRecord
                  medicineList={medicineList}
                  handleQRCode={handleQRCode}
                  fromEmailMeetingId={
                    meetinId ? meetinId : medicineList?.[0]?.meeting_id
                  }
                  handlePatientEditInfo={handleDoctorInfo}
                  isOpenMailModal={isOpenMailModal}
                  handlePatientInfo={handlePatientInfo}
                  // meetingData={meetingData}
                  from=""
                  type="final_pres"
                  settypepres={settypepres}
                />
              </div>
            </div>
          </div>
        </section>
        {/* <Footer /> */}
      </main>
    </>
  );
}

const PocPrescriptionWrpper = styled.div`
  @media (max-width: 480px) {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    button {
      width: 100%;
      max-width: 100% !important;
    }
  }
`;

export default PostralReport;
